// extracted by mini-css-extract-plugin
export default {"bar":"yGxTlqYK4SOGml6740zM","active":"OrluFCZPwTWmdx0tZAsW","inactive":"Gxq0_NU1GQwI_twgpnBe","upselling":"v0EOewPe7O08MTW5to16","textNoWrap":"k4mzVAArmsvKHGGLdmLw"};